import React from "react";
import { Link } from "react-router-dom";
import FacebookIcon from "../../assets/svg/facebook.svg";
import InstagramIcon from "../../assets/svg/instagram.svg";
import LinkedInIcon from "../../assets/svg/linked-in.svg";
import SharePointIcon from "../../assets/svg/sharepoint.svg";
import TwitterIcon from "../../assets/svg/twitter.svg";
import YoutubeIcon from "../../assets/svg/youtube.svg";
import CSCLogo from "../../assets/csc-logo-white 1.png";
import AccessibilityPolicyLogo from "../../assets/accessibility-policy.png";
import { getYear } from "../../utils/formatTime";

function Footer() {
  const isUserLogged = JSON.parse(sessionStorage?.getItem("isLoggedIn"));
  const isADAEnabled = JSON?.parse(`${process.env.REACT_APP_ADA_OPTION}`);
  return (
    <footer role="contentinfo" aria-label="Footer" className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 footer-contact">
            <h4 className="footer-title">Contact Us</h4>
            <div className="contact-info">
              <p>
                6600 West Commercial Boulevard
                <br />
                Lauderhill, FL 33319
              </p>
              <p>
                <a href="tel:(954) 377-1000" aria-label="Call (954) 377-1000">
                  (954) 377-1000
                </a>
              </p>
              {/* <p>info@cscbroward.org</p> */}
              <a
                className="a-link"
                href="mailto:help@browardpartnershipsforkids.org"
                aria-label="Send email to help@browardpartnershipsforkids.org"
              >
                help@browardpartnershipsforkids.org
              </a>
            </div>
          </div>

          <div className="col-lg-4 footer-follow-us">
            {/* <h4 className="footer-title">Useful Links</h4>
            <ul className="footer-list-style">
              <li>
                <a href="#bcsp-committee-slider">BPK Committees</a>
              </li>
              {!isUserLogged && (
                <li>
                  <Link to="/register">Join A BCSP Committee</Link>
                </li>
              )}
              <li>
                <a href="#bcsp-calendar">Calendar</a>
              </li>
              <li>
                <a
                  href="https://www.results4browardchildren.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  CSC Website
                </a>
              </li>
            </ul> */}
            <h4 className="footer-title">Follow us</h4>
            <div className="social-icons py-3 ">
              <a
                href="https://www.facebook.com/cscbroward"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="CSC Broward on Facebook (opens in a new tab)"
              >
                <img src={FacebookIcon} alt="Facebook" />
              </a>
              <a
                href="https://x.com/cscbroward"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="CSC Broward on X / Twitter (opens in a new tab)"
              >
                <img src={TwitterIcon} alt="Twitter" />
              </a>
              <a
                href="https://www.instagram.com/cscbroward"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="CSC Broward on Instagram (opens in a new tab)"
              >
                <img src={InstagramIcon} alt="Instagram" />
              </a>
              <a
                href="https://www.linkedin.com/company/children's-services-council-of-broward-county/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="CSC Broward on LinkedIn (opens in a new tab)"
              >
                <img src={LinkedInIcon} alt="LinkedIn" />
              </a>
              <a
                href="https://www.youtube.com/user/CSCBroward"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="CSC Broward on YouTube (opens in a new tab)"
              >
                <img src={YoutubeIcon} alt="YouTube" />
              </a>
            </div>
            <h4>
              <Link to="/PrivacyPolicy" aria-label="Privacy Policy">
                Privacy Policy
              </Link>
            </h4>
          </div>

          <div className="col-lg-4 footer-logo">
            <div className="div-center mb-5">
              <a
                href="https://www.cscbroward.org/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Children's Services Council of Broward County website (opens in a new tab)"
              >
                <img
                  src={CSCLogo}
                  alt="Children's Services Council of Broward County Logo"
                />
              </a>
            </div>
            {isADAEnabled && (
              <div className="div-center mb-3">
                <img
                  src={AccessibilityPolicyLogo}
                  alt="Accessibility Policy Logo"
                />
              </div>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center footer-text">
          {` Copyright © ${getYear()} by Broward Partnerships For Kids. All Rights Reserved.`}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
